module.exports = __webpack_public_path__ + "img/logo_festival.63be9f37.jpg";